<dx-list [dataSource]="groupedConversations"
         class="conversation-list"
         [grouped]="true"
         *adaptLoading="!isInitialised"
         noDataText="No past conversation"
         groupTemplate="conversationGroupTemplate"
         itemTemplate="conversationItemTemplate"
         (onItemClick)="switchConversation($event)">
    <div *dxTemplate="let group of 'conversationGroupTemplate'"
         class="conversation-group-header">
        {{ group.key }}
    </div>

    <div *dxTemplate="let item of 'conversationItemTemplate'"
         class="conversation-list-item">
        <div class="conversation-list-subject"
             [ngClass]="{'active': item.conversationId === currentConversationId}">{{ item.subject }}</div>
        <div class="conversation-list-timestamp">{{ formatConversationTime(item.endTime) }}</div>
        <i #conversationMenu
           class="btn-blank fal fa-fw fa-ellipsis-vertical"
           (click)="toggleConversationPopover($event, item.conversationId)"></i>
        <!-- need the d-none for this or it will cause a gap in the row when popover visible -->
        <dx-popover #conversationMenuPopover
                    [attr.data-conversation-id]="item.conversationId"
                    [wrapperAttr]="{ class: 'conversation-wrapper', 'data-bs-theme': swatchTheme }"
                    class="d-none"
                    [target]="conversationMenu"
                    [hideOnOutsideClick]="true"
                    [position]="{  my: 'left top', at: 'left bottom', offset: '0 -10' }"
                    (onShowing)="onConversationPopoverShowing($event, item.conversationId)"
                    (onHiding)="onConversationPopoverHiding($event, item.conversationId)">
            <div *dxTemplate="let data of 'content'"
                 class="d-flex flex-column conversation-menu-popover-content">
                <adapt-menu [items]="getItemMenu(item)"
                            orientation="vertical"></adapt-menu>
            </div>
        </dx-popover>
    </div>
</dx-list>

<dx-load-panel class="dx-load-panel"
               [shadingColor]="'rgba(0,0,0,0.05)'"
               [position]="{ of: '.conversation-list' }"
               [visible]="loading"
               [showIndicator]="true"
               [showPane]="true"
               [shading]="true"
               [hideOnOutsideClick]="false"> </dx-load-panel>
